export default "__VITE_ASSET__BhLTV9p4__"